var map = {
	"./act": 1519,
	"./act.ts": 1519,
	"./gmat": 1520,
	"./gmat.ts": 1520,
	"./gre": 1521,
	"./gre.ts": 1521,
	"./ielts": 1522,
	"./ielts.ts": 1522,
	"./ielts_general_training": 1523,
	"./ielts_general_training.ts": 1523,
	"./lsat": 1524,
	"./lsat.ts": 1524,
	"./mcat": 1525,
	"./mcat.ts": 1525,
	"./sat": 1526,
	"./sat.ts": 1526,
	"./toefl": 1527,
	"./toefl.ts": 1527
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2531;
module.exports = webpackAsyncContext;